module.exports = __webpack_public_path__ + "static/img/fitzroy.402cd1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/fitzroy.jpg
// module id = hC4n
// module chunks = 1